import React from 'react'
import Layout from '../../common/Layout'
import AdministratorsContainer from '../../features/AdministrationPortal/Administrators/AdministratorsContainer/AdministratorsContainer'
import 'bootstrap/dist/css/bootstrap.min.css';

export default {
  path: '/administration/administrators',
  async action () {
    return {
      title: 'Administrators',
      component: <Layout containerWell>
        <AdministratorsContainer />
      </Layout>
    }
  }
}
